import { mmToMeters } from "@buildwithflux/shared";
import { chipComputeInferredRules, chipGenerateAdditionalPads, chipGeneratePadRules, chipGenerateSilkNodes, chipPackageDimensions, getChipConfig, } from "./packages/chip";
import { commonGenerate3DModelNode } from "./packages/common";
import { dfnComputeInferredRules, dfnGenerateAdditionalPads, dfnGeneratePadRules, dfnGenerateSilkNodes, } from "./packages/dfn";
import { dipComputeInferredRules, dipGenerateAdditionalPads, dipGeneratePadRules, dipGenerateSilkNodes, sipGenerateSilkNodes, } from "./packages/dip";
import { gridArrayComputeInferredRules, gridArrayGeneratePadRules, gridArrayGenerateSilkNodes, } from "./packages/gridArray";
import { lgaComputeInferredRules, lgaGenerateAdditionalPads, lgaGeneratePadRules, lgaGenerateSilkNodes, } from "./packages/lga";
import { lqfpComputeInferredRules, lqfpGenerateAdditionalPads, lqfpGeneratePadRules, lqfpGenerateSilkNodes, } from "./packages/lqfp";
import { qfnComputeInferredRules, qfnGenerateAdditionalPads, qfnGeneratePadRules, qfnGenerateSilkNodes, } from "./packages/qfn";
import { soicComputeInferredRules, soicGenerateAdditionalPads, soicGeneratePadRules, soicGenerateSilkNodes, } from "./packages/soic";
import { getSotConfig, sotComputeInferredRules, sotGenerateAdditionalPads, sotGeneratePadRules, sotGenerateSilkNodes, } from "./packages/sot";
import { ssopComputeInferredRules, ssopGenerateAdditionalPads, ssopGeneratePadRules, ssopGenerateSilkNodes, } from "./packages/ssop";
import { getToConfig, toComputeInferredRules, toGenerateAdditionalPads, toGeneratePadRules, toGenerateSilkNodes, } from "./packages/to";
import { tssopComputeInferredRules, tssopGenerateAdditionalPads, tssopGeneratePadRules, tssopGenerateSilkNodes, } from "./packages/tssop";
export const packages = {
    "Grid Array": {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 1 / 1000,
            pinSize: 0.3 / 1000,
            pinPitch: 0.65 / 1000,
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    BGA: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 1.2 / 1000,
            pinSize: 0.4 / 1000,
            pinPitch: 0.8 / 1000,
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    CSP: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 0.6 / 1000,
            pinSize: 0.2 / 1000,
            pinPitch: 0.4 / 1000,
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // BGA variants - Fine-pitch Ball Grid Array
    FBGA: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 1.0 / 1000, // Thinner than standard BGA
            pinSize: 0.3 / 1000, // Smaller ball size for fine pitch
            pinPitch: 0.5 / 1000, // Fine pitch
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Low-profile Fine-pitch Ball Grid Array
    LFBGA: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 0.8 / 1000, // Low profile
            pinSize: 0.3 / 1000,
            pinPitch: 0.5 / 1000,
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Thin Fine-pitch Ball Grid Array
    TFBGA: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 0.7 / 1000, // Thin profile
            pinSize: 0.25 / 1000,
            pinPitch: 0.4 / 1000,
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Very Fine-pitch Ball Grid Array
    VFBGA: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 0.8 / 1000,
            pinSize: 0.2 / 1000, // Very small balls
            pinPitch: 0.35 / 1000, // Very fine pitch
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Ultra Fine-pitch Ball Grid Array
    UFBGA: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 0.6 / 1000,
            pinSize: 0.15 / 1000, // Ultra small balls
            pinPitch: 0.3 / 1000, // Ultra fine pitch
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Wafer-level Fine-pitch Ball Grid Array
    WFBGA: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 0.5 / 1000, // Very thin wafer-level
            pinSize: 0.2 / 1000,
            pinPitch: 0.4 / 1000,
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Flip Chip Ball Grid Array
    FCBGA: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 2.0 / 1000, // Larger for flip chip
            pinSize: 0.5 / 1000,
            pinPitch: 1.0 / 1000,
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Ultra Chip-scale Ball Grid Array
    UCBGA: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 0.5 / 1000, // Ultra thin
            pinSize: 0.2 / 1000,
            pinPitch: 0.4 / 1000,
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Tape Ball Grid Array
    TBGA: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 1.5 / 1000,
            pinSize: 0.45 / 1000,
            pinPitch: 0.8 / 1000,
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Die-Size Ball Grid Array
    DSBGA: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 0.4 / 1000, // Die-size, very thin
            pinSize: 0.2 / 1000,
            pinPitch: 0.35 / 1000,
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Plastic Ball Grid Array
    PBGA: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 2.3 / 1000, // Larger plastic package
            pinSize: 0.6 / 1000,
            pinPitch: 1.27 / 1000, // Standard 1.27mm pitch
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Chip Array Ball Grid Array
    CABGA: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 1.0 / 1000,
            pinSize: 0.35 / 1000,
            pinPitch: 0.5 / 1000,
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Ultra Ball Grid Array
    UBGA: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 0.6 / 1000,
            pinSize: 0.25 / 1000,
            pinPitch: 0.4 / 1000,
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // X Ball Grid Array (generic extended BGA)
    XBGA: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 1.2 / 1000,
            pinSize: 0.4 / 1000,
            pinPitch: 0.65 / 1000,
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    LGA: {
        computeInferredRules: (br, existingPadNodes) => lgaComputeInferredRules(br, {
            packageHeight: 0.8 / 1000, // LGAs are typically thinner than BGAs
            pinSize: 0.4 / 1000, // Typical LGA pad size
            pinPitch: 0.8 / 1000, // Common LGA pitch
        }, existingPadNodes),
        generatePadRules: lgaGeneratePadRules,
        generateAdditionalPads: lgaGenerateAdditionalPads,
        generateSilkNodes: lgaGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode, // Reuse the common 3D model generator
    },
    LQFP: {
        computeInferredRules: (br, existingPadNodes) => lqfpComputeInferredRules(br, {
            packageHeight: 1.4 / 1000, // Typical LQFP height
            pinSizeX: 0.3 / 1000,
            pinSizeY: 1.0 / 1000, // Longer for leads
            pinPitch: 0.5 / 1000,
            padOuterMargin: 0.5 / 1000,
        }, existingPadNodes),
        generatePadRules: lqfpGeneratePadRules,
        generateAdditionalPads: lqfpGenerateAdditionalPads,
        generateSilkNodes: lqfpGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    MSOP: {
        computeInferredRules: (br, existingPadNodes) => ssopComputeInferredRules(br, {
            packageHeight: 1.0 / 1000, // Smaller height for MSOP
            pinSizeX: 0.25 / 1000, // Smaller pad width
            pinSizeY: 0.8 / 1000, // Smaller pad length
            pinPitch: 0.5 / 1000, // Finer pitch for MSOP
            padOuterMargin: 0.25 / 1000, // Distance from package edge
        }, existingPadNodes),
        generatePadRules: ssopGeneratePadRules,
        generateAdditionalPads: ssopGenerateAdditionalPads,
        generateSilkNodes: ssopGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    QFN: {
        computeInferredRules: (br, existingPadNodes) => qfnComputeInferredRules(br, {
            packageHeight: 1 / 1000,
            pinSizeX: 0.25 / 1000,
            pinSizeY: 0.5 / 1000,
            pinPitch: 0.5 / 1000,
            padOuterMargin: 0.4 / 1000,
        }, existingPadNodes),
        generatePadRules: qfnGeneratePadRules,
        generateAdditionalPads: qfnGenerateAdditionalPads,
        generateSilkNodes: qfnGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // QFN variants - Very Thin Quad Flat No-lead
    VQFN: {
        computeInferredRules: (br, existingPadNodes) => qfnComputeInferredRules(br, {
            packageHeight: 0.85 / 1000, // Very thin
            pinSizeX: 0.25 / 1000,
            pinSizeY: 0.4 / 1000,
            pinPitch: 0.5 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: qfnGeneratePadRules,
        generateAdditionalPads: qfnGenerateAdditionalPads,
        generateSilkNodes: qfnGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Wettable Flank Quad Flat No-lead
    WQFN: {
        computeInferredRules: (br, existingPadNodes) => qfnComputeInferredRules(br, {
            packageHeight: 0.9 / 1000,
            pinSizeX: 0.25 / 1000,
            pinSizeY: 0.5 / 1000,
            pinPitch: 0.5 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: qfnGeneratePadRules,
        generateAdditionalPads: qfnGenerateAdditionalPads,
        generateSilkNodes: qfnGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Thin Quad Flat No-lead
    TQFN: {
        computeInferredRules: (br, existingPadNodes) => qfnComputeInferredRules(br, {
            packageHeight: 0.75 / 1000, // Thin
            pinSizeX: 0.2 / 1000,
            pinSizeY: 0.4 / 1000,
            pinPitch: 0.4 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: qfnGeneratePadRules,
        generateAdditionalPads: qfnGenerateAdditionalPads,
        generateSilkNodes: qfnGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Ultra-thin Quad Flat No-lead
    UQFN: {
        computeInferredRules: (br, existingPadNodes) => qfnComputeInferredRules(br, {
            packageHeight: 0.55 / 1000, // Ultra thin
            pinSizeX: 0.2 / 1000,
            pinSizeY: 0.35 / 1000,
            pinPitch: 0.4 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: qfnGeneratePadRules,
        generateAdditionalPads: qfnGenerateAdditionalPads,
        generateSilkNodes: qfnGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Heat-sink Very Thin Quad Flat No-lead
    HVQFN: {
        computeInferredRules: (br, existingPadNodes) => qfnComputeInferredRules(br, {
            packageHeight: 0.85 / 1000,
            pinSizeX: 0.25 / 1000,
            pinSizeY: 0.5 / 1000,
            pinPitch: 0.5 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: qfnGeneratePadRules,
        generateAdditionalPads: qfnGenerateAdditionalPads,
        generateSilkNodes: qfnGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Very Fine-pitch Quad Flat No-lead
    VFQFN: {
        computeInferredRules: (br, existingPadNodes) => qfnComputeInferredRules(br, {
            packageHeight: 0.9 / 1000,
            pinSizeX: 0.15 / 1000, // Very fine pitch
            pinSizeY: 0.3 / 1000,
            pinPitch: 0.35 / 1000, // Very fine pitch
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: qfnGeneratePadRules,
        generateAdditionalPads: qfnGenerateAdditionalPads,
        generateSilkNodes: qfnGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Wettable Flank Fine-pitch Quad Flat No-lead
    WFQFN: {
        computeInferredRules: (br, existingPadNodes) => qfnComputeInferredRules(br, {
            packageHeight: 0.9 / 1000,
            pinSizeX: 0.2 / 1000,
            pinSizeY: 0.4 / 1000,
            pinPitch: 0.4 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: qfnGeneratePadRules,
        generateAdditionalPads: qfnGenerateAdditionalPads,
        generateSilkNodes: qfnGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Ultra Fine-pitch Quad Flat Package No-lead
    UFQFPN: {
        computeInferredRules: (br, existingPadNodes) => qfnComputeInferredRules(br, {
            packageHeight: 0.55 / 1000,
            pinSizeX: 0.15 / 1000,
            pinSizeY: 0.3 / 1000,
            pinPitch: 0.3 / 1000, // Ultra fine pitch
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: qfnGeneratePadRules,
        generateAdditionalPads: qfnGenerateAdditionalPads,
        generateSilkNodes: qfnGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    SSOP: {
        computeInferredRules: (br, existingPadNodes) => ssopComputeInferredRules(br, {
            packageHeight: 2.5 / 1000, // Appropriate height for SSOP
            pinSizeX: 0.3 / 1000, // Typical pad width
            pinSizeY: 1.0 / 1000, // Typical pad length
            pinPitch: 0.65 / 1000, // Standard SSOP pitch
            padOuterMargin: 0.25 / 1000, // Distance from package edge
        }, existingPadNodes),
        generatePadRules: ssopGeneratePadRules,
        generateAdditionalPads: ssopGenerateAdditionalPads,
        generateSilkNodes: ssopGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // SSOP variants - Very Small Shrink Small Outline Package
    VSSOP: {
        computeInferredRules: (br, existingPadNodes) => ssopComputeInferredRules(br, {
            packageHeight: 1.1 / 1000, // Very small
            pinSizeX: 0.25 / 1000,
            pinSizeY: 0.75 / 1000,
            pinPitch: 0.5 / 1000, // Finer pitch
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: ssopGeneratePadRules,
        generateAdditionalPads: ssopGenerateAdditionalPads,
        generateSilkNodes: ssopGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // High Voltage Shrink Small Outline Package
    HVSSOP: {
        computeInferredRules: (br, existingPadNodes) => ssopComputeInferredRules(br, {
            packageHeight: 2.0 / 1000,
            pinSizeX: 0.35 / 1000,
            pinSizeY: 1.0 / 1000,
            pinPitch: 0.65 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: ssopGeneratePadRules,
        generateAdditionalPads: ssopGenerateAdditionalPads,
        generateSilkNodes: ssopGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Quarter Size Small Outline Package
    QSOP: {
        computeInferredRules: (br, existingPadNodes) => ssopComputeInferredRules(br, {
            packageHeight: 1.75 / 1000,
            pinSizeX: 0.3 / 1000,
            pinSizeY: 0.9 / 1000,
            pinPitch: 0.635 / 1000, // 25 mil pitch
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: ssopGeneratePadRules,
        generateAdditionalPads: ssopGenerateAdditionalPads,
        generateSilkNodes: ssopGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Micro Shrink Small Outline Package
    MSSSOP: {
        computeInferredRules: (br, existingPadNodes) => ssopComputeInferredRules(br, {
            packageHeight: 0.8 / 1000,
            pinSizeX: 0.22 / 1000,
            pinSizeY: 0.65 / 1000,
            pinPitch: 0.5 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: ssopGeneratePadRules,
        generateAdditionalPads: ssopGenerateAdditionalPads,
        generateSilkNodes: ssopGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Very Thin Shrink Small Outline Package
    VTSOP: {
        computeInferredRules: (br, existingPadNodes) => ssopComputeInferredRules(br, {
            packageHeight: 0.65 / 1000, // Very thin
            pinSizeX: 0.2 / 1000,
            pinSizeY: 0.6 / 1000,
            pinPitch: 0.4 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: ssopGeneratePadRules,
        generateAdditionalPads: ssopGenerateAdditionalPads,
        generateSilkNodes: ssopGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // TSOP - Thin Small Outline Package (memory packages)
    TSOP: {
        computeInferredRules: (br, existingPadNodes) => ssopComputeInferredRules(br, {
            packageHeight: 1.0 / 1000,
            pinSizeX: 0.22 / 1000,
            pinSizeY: 0.6 / 1000,
            pinPitch: 0.5 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: ssopGeneratePadRules,
        generateAdditionalPads: ssopGenerateAdditionalPads,
        generateSilkNodes: ssopGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // TSOP Type I (pins on short sides)
    "TSOP-I": {
        computeInferredRules: (br, existingPadNodes) => ssopComputeInferredRules(br, {
            packageHeight: 1.0 / 1000,
            pinSizeX: 0.22 / 1000,
            pinSizeY: 0.6 / 1000,
            pinPitch: 0.5 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: ssopGeneratePadRules,
        generateAdditionalPads: ssopGenerateAdditionalPads,
        generateSilkNodes: ssopGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // TSOP Type II (pins on long sides)
    "TSOP-II": {
        computeInferredRules: (br, existingPadNodes) => ssopComputeInferredRules(br, {
            packageHeight: 1.0 / 1000,
            pinSizeX: 0.22 / 1000,
            pinSizeY: 0.6 / 1000,
            pinPitch: 0.5 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: ssopGeneratePadRules,
        generateAdditionalPads: ssopGenerateAdditionalPads,
        generateSilkNodes: ssopGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // PLCC - Plastic Leaded Chip Carrier (uses QFP-style 4-sided layout)
    PLCC: {
        computeInferredRules: (br, existingPadNodes) => lqfpComputeInferredRules(br, {
            packageHeight: 4.5 / 1000, // Thicker package
            pinSizeX: 0.6 / 1000,
            pinSizeY: 2.0 / 1000,
            pinPitch: 1.27 / 1000, // 50 mil pitch
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: lqfpGeneratePadRules,
        generateAdditionalPads: lqfpGenerateAdditionalPads,
        generateSilkNodes: lqfpGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // QFP variants - Quad Flat Package
    QFP: {
        computeInferredRules: (br, existingPadNodes) => lqfpComputeInferredRules(br, {
            packageHeight: 2.0 / 1000,
            pinSizeX: 0.4 / 1000,
            pinSizeY: 1.2 / 1000,
            pinPitch: 0.65 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: lqfpGeneratePadRules,
        generateAdditionalPads: lqfpGenerateAdditionalPads,
        generateSilkNodes: lqfpGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Very Thin Quad Flat Package
    VQFP: {
        computeInferredRules: (br, existingPadNodes) => lqfpComputeInferredRules(br, {
            packageHeight: 1.0 / 1000, // Very thin
            pinSizeX: 0.3 / 1000,
            pinSizeY: 1.0 / 1000,
            pinPitch: 0.5 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: lqfpGeneratePadRules,
        generateAdditionalPads: lqfpGenerateAdditionalPads,
        generateSilkNodes: lqfpGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Plastic Quad Flat Package
    PQFP: {
        computeInferredRules: (br, existingPadNodes) => lqfpComputeInferredRules(br, {
            packageHeight: 3.4 / 1000,
            pinSizeX: 0.4 / 1000,
            pinSizeY: 1.5 / 1000,
            pinPitch: 0.65 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: lqfpGeneratePadRules,
        generateAdditionalPads: lqfpGenerateAdditionalPads,
        generateSilkNodes: lqfpGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Ceramic Quad Flat Package
    CQFP: {
        computeInferredRules: (br, existingPadNodes) => lqfpComputeInferredRules(br, {
            packageHeight: 4.0 / 1000, // Ceramic is thicker
            pinSizeX: 0.5 / 1000,
            pinSizeY: 1.5 / 1000,
            pinPitch: 0.8 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: lqfpGeneratePadRules,
        generateAdditionalPads: lqfpGenerateAdditionalPads,
        generateSilkNodes: lqfpGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Bumpered Quad Flat Package
    BQFP: {
        computeInferredRules: (br, existingPadNodes) => lqfpComputeInferredRules(br, {
            packageHeight: 3.0 / 1000,
            pinSizeX: 0.4 / 1000,
            pinSizeY: 1.2 / 1000,
            pinPitch: 0.635 / 1000, // 25 mil pitch
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: lqfpGeneratePadRules,
        generateAdditionalPads: lqfpGenerateAdditionalPads,
        generateSilkNodes: lqfpGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Heat-sink Quad Flat Package
    HQFP: {
        computeInferredRules: (br, existingPadNodes) => lqfpComputeInferredRules(br, {
            packageHeight: 2.5 / 1000,
            pinSizeX: 0.4 / 1000,
            pinSizeY: 1.2 / 1000,
            pinPitch: 0.65 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: lqfpGeneratePadRules,
        generateAdditionalPads: lqfpGenerateAdditionalPads,
        generateSilkNodes: lqfpGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // WLP - Wafer Level Package (similar to BGA but smaller)
    WLP: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 0.5 / 1000, // Very thin
            pinSize: 0.25 / 1000, // Small ball size
            pinPitch: 0.4 / 1000, // Fine pitch
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // WLCSP - Wafer Level Chip Scale Package
    WLCSP: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 0.4 / 1000, // Ultra thin
            pinSize: 0.2 / 1000,
            pinPitch: 0.35 / 1000,
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Fan-out Wafer Level Package
    FOWLP: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 0.5 / 1000,
            pinSize: 0.25 / 1000,
            pinPitch: 0.4 / 1000,
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    TQFP: {
        computeInferredRules: (br, existingPadNodes) => lqfpComputeInferredRules(br, {
            packageHeight: 1.0 / 1000, // Thinner than LQFP
            pinSizeX: 0.3 / 1000,
            pinSizeY: 1.0 / 1000,
            pinPitch: 0.5 / 1000,
            padOuterMargin: 0.5 / 1000,
        }, existingPadNodes),
        generatePadRules: lqfpGeneratePadRules,
        generateAdditionalPads: lqfpGenerateAdditionalPads,
        generateSilkNodes: lqfpGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // SOIC packages
    SOIC: {
        computeInferredRules: (br, existingPadNodes) => soicComputeInferredRules(br, {
            packageHeight: 1.75 / 1000,
            pinSizeX: 0.6 / 1000,
            pinSizeY: 1.5 / 1000,
            pinPitch: 1.27 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: soicGeneratePadRules,
        generateAdditionalPads: soicGenerateAdditionalPads,
        generateSilkNodes: soicGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    SOP: {
        computeInferredRules: (br, existingPadNodes) => soicComputeInferredRules(br, {
            packageHeight: 1.75 / 1000,
            pinSizeX: 0.6 / 1000,
            pinSizeY: 1.5 / 1000,
            pinPitch: 1.27 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: soicGeneratePadRules,
        generateAdditionalPads: soicGenerateAdditionalPads,
        generateSilkNodes: soicGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // TSSOP packages
    TSSOP: {
        computeInferredRules: (br, existingPadNodes) => tssopComputeInferredRules(br, {
            packageHeight: 1.0 / 1000,
            pinSizeX: 0.3 / 1000,
            pinSizeY: 0.8 / 1000,
            pinPitch: 0.65 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: tssopGeneratePadRules,
        generateAdditionalPads: tssopGenerateAdditionalPads,
        generateSilkNodes: tssopGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // DFN/WSON packages
    DFN: {
        computeInferredRules: (br, existingPadNodes) => dfnComputeInferredRules(br, {
            packageHeight: 0.8 / 1000,
            pinSizeX: 0.25 / 1000,
            pinSizeY: 0.4 / 1000,
            pinPitch: 0.5 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: dfnGeneratePadRules,
        generateAdditionalPads: dfnGenerateAdditionalPads,
        generateSilkNodes: dfnGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    WSON: {
        computeInferredRules: (br, existingPadNodes) => dfnComputeInferredRules(br, {
            packageHeight: 0.8 / 1000,
            pinSizeX: 0.25 / 1000,
            pinSizeY: 0.5 / 1000,
            pinPitch: 0.5 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: dfnGeneratePadRules,
        generateAdditionalPads: dfnGenerateAdditionalPads,
        generateSilkNodes: dfnGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // DFN variants - Thin Dual Flat No-lead
    TDFN: {
        computeInferredRules: (br, existingPadNodes) => dfnComputeInferredRules(br, {
            packageHeight: 0.6 / 1000, // Thin
            pinSizeX: 0.25 / 1000,
            pinSizeY: 0.4 / 1000,
            pinPitch: 0.5 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: dfnGeneratePadRules,
        generateAdditionalPads: dfnGenerateAdditionalPads,
        generateSilkNodes: dfnGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Very Very Thin Dual Flat No-lead
    WDFN: {
        computeInferredRules: (br, existingPadNodes) => dfnComputeInferredRules(br, {
            packageHeight: 0.55 / 1000, // Very thin
            pinSizeX: 0.2 / 1000,
            pinSizeY: 0.35 / 1000,
            pinPitch: 0.4 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: dfnGeneratePadRules,
        generateAdditionalPads: dfnGenerateAdditionalPads,
        generateSilkNodes: dfnGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Ultra-thin Dual Flat No-lead
    UDFN: {
        computeInferredRules: (br, existingPadNodes) => dfnComputeInferredRules(br, {
            packageHeight: 0.4 / 1000, // Ultra thin
            pinSizeX: 0.2 / 1000,
            pinSizeY: 0.3 / 1000,
            pinPitch: 0.4 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: dfnGeneratePadRules,
        generateAdditionalPads: dfnGenerateAdditionalPads,
        generateSilkNodes: dfnGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Very Thin Dual Flat No-lead
    VDFN: {
        computeInferredRules: (br, existingPadNodes) => dfnComputeInferredRules(br, {
            packageHeight: 0.65 / 1000,
            pinSizeX: 0.25 / 1000,
            pinSizeY: 0.4 / 1000,
            pinPitch: 0.5 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: dfnGeneratePadRules,
        generateAdditionalPads: dfnGenerateAdditionalPads,
        generateSilkNodes: dfnGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // X Dual Flat No-lead (generic extended DFN)
    XDFN: {
        computeInferredRules: (br, existingPadNodes) => dfnComputeInferredRules(br, {
            packageHeight: 0.75 / 1000,
            pinSizeX: 0.25 / 1000,
            pinSizeY: 0.45 / 1000,
            pinPitch: 0.5 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: dfnGeneratePadRules,
        generateAdditionalPads: dfnGenerateAdditionalPads,
        generateSilkNodes: dfnGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Very Small Outline No-lead
    VSON: {
        computeInferredRules: (br, existingPadNodes) => dfnComputeInferredRules(br, {
            packageHeight: 0.8 / 1000,
            pinSizeX: 0.25 / 1000,
            pinSizeY: 0.5 / 1000,
            pinPitch: 0.5 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: dfnGeneratePadRules,
        generateAdditionalPads: dfnGenerateAdditionalPads,
        generateSilkNodes: dfnGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Ultra Small Outline No-lead
    USON: {
        computeInferredRules: (br, existingPadNodes) => dfnComputeInferredRules(br, {
            packageHeight: 0.5 / 1000, // Ultra small
            pinSizeX: 0.2 / 1000,
            pinSizeY: 0.35 / 1000,
            pinPitch: 0.4 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: dfnGeneratePadRules,
        generateAdditionalPads: dfnGenerateAdditionalPads,
        generateSilkNodes: dfnGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // DIP packages
    DIP: {
        computeInferredRules: (br, existingPadNodes) => dipComputeInferredRules(br, {
            packageHeight: 3.3 / 1000,
            pinSizeX: 1.6 / 1000,
            pinSizeY: 1.6 / 1000,
            pinPitch: 2.54 / 1000,
            rowSpacing: 7.62 / 1000, // 0.3" DIP
            holeDiameter: 0.8 / 1000,
        }, existingPadNodes),
        generatePadRules: dipGeneratePadRules,
        generateAdditionalPads: dipGenerateAdditionalPads,
        generateSilkNodes: dipGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    PDIP: {
        computeInferredRules: (br, existingPadNodes) => dipComputeInferredRules(br, {
            packageHeight: 3.3 / 1000,
            pinSizeX: 1.6 / 1000,
            pinSizeY: 1.6 / 1000,
            pinPitch: 2.54 / 1000,
            rowSpacing: 7.62 / 1000,
            holeDiameter: 0.8 / 1000,
        }, existingPadNodes),
        generatePadRules: dipGeneratePadRules,
        generateAdditionalPads: dipGenerateAdditionalPads,
        generateSilkNodes: dipGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Skinny DIP (narrow body)
    SDIP: {
        computeInferredRules: (br, existingPadNodes) => dipComputeInferredRules(br, {
            packageHeight: 3.3 / 1000,
            pinSizeX: 1.6 / 1000,
            pinSizeY: 1.6 / 1000,
            pinPitch: 2.54 / 1000,
            rowSpacing: 7.62 / 1000, // 0.3" narrow
            holeDiameter: 0.8 / 1000,
        }, existingPadNodes),
        generatePadRules: dipGeneratePadRules,
        generateAdditionalPads: dipGenerateAdditionalPads,
        generateSilkNodes: dipGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Shrink DIP
    SPDIP: {
        computeInferredRules: (br, existingPadNodes) => dipComputeInferredRules(br, {
            packageHeight: 3.3 / 1000,
            pinSizeX: 1.4 / 1000,
            pinSizeY: 1.4 / 1000,
            pinPitch: 1.778 / 1000, // 70 mil pitch
            rowSpacing: 7.62 / 1000,
            holeDiameter: 0.7 / 1000,
        }, existingPadNodes),
        generatePadRules: dipGeneratePadRules,
        generateAdditionalPads: dipGenerateAdditionalPads,
        generateSilkNodes: dipGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Ceramic DIP
    CDIP: {
        computeInferredRules: (br, existingPadNodes) => dipComputeInferredRules(br, {
            packageHeight: 4.0 / 1000, // Ceramic is typically taller
            pinSizeX: 1.6 / 1000,
            pinSizeY: 1.6 / 1000,
            pinPitch: 2.54 / 1000,
            rowSpacing: 7.62 / 1000,
            holeDiameter: 0.8 / 1000,
        }, existingPadNodes),
        generatePadRules: dipGeneratePadRules,
        generateAdditionalPads: dipGenerateAdditionalPads,
        generateSilkNodes: dipGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // SIP - Single In-line Package (uses DIP generator with single row, but dedicated silkscreen)
    SIP: {
        computeInferredRules: (br, existingPadNodes) => dipComputeInferredRules(br, {
            packageHeight: 8.0 / 1000, // Taller for single row
            pinSizeX: 1.6 / 1000,
            pinSizeY: 1.6 / 1000,
            pinPitch: 2.54 / 1000,
            rowSpacing: 0, // Single row
            holeDiameter: 0.8 / 1000,
        }, existingPadNodes),
        generatePadRules: dipGeneratePadRules,
        generateAdditionalPads: dipGenerateAdditionalPads,
        generateSilkNodes: sipGenerateSilkNodes, // Use dedicated SIP silkscreen generator
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // ZIP - Zig-zag In-line Package
    ZIP: {
        computeInferredRules: (br, existingPadNodes) => dipComputeInferredRules(br, {
            packageHeight: 8.0 / 1000,
            pinSizeX: 1.6 / 1000,
            pinSizeY: 1.6 / 1000,
            pinPitch: 2.54 / 1000,
            rowSpacing: 2.54 / 1000, // Zig-zag offset
            holeDiameter: 0.8 / 1000,
        }, existingPadNodes),
        generatePadRules: dipGeneratePadRules,
        generateAdditionalPads: dipGenerateAdditionalPads,
        generateSilkNodes: dipGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // TO packages
    "TO-92": {
        computeInferredRules: (br, existingPadNodes) => {
            const config = getToConfig("TO-92");
            return toComputeInferredRules(br, {
                packageHeight: (config?.packageHeight ?? 4.0) / 1000,
                pinSizeX: (config?.pinSizeX ?? 0.8) / 1000,
                pinSizeY: (config?.pinSizeY ?? 0.8) / 1000,
                pinPitch: (config?.pinPitch ?? 1.27) / 1000,
                packageWidth: (config?.packageWidth ?? 4.5) / 1000,
                packageDepth: (config?.packageDepth ?? 3.5) / 1000,
                holeDiameter: (config?.holeDiameter ?? 0.7) / 1000,
                isSMD: config?.isSMD ?? false,
            }, existingPadNodes);
        },
        generatePadRules: (footprintNodeUid, bakedRules) => toGeneratePadRules(footprintNodeUid, bakedRules, { isSMD: false, holeDiameter: 0.7 / 1000 }),
        generateAdditionalPads: toGenerateAdditionalPads,
        generateSilkNodes: toGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    "TO-220": {
        computeInferredRules: (br, existingPadNodes) => {
            const config = getToConfig("TO-220");
            return toComputeInferredRules(br, {
                packageHeight: (config?.packageHeight ?? 15.0) / 1000,
                pinSizeX: (config?.pinSizeX ?? 1.4) / 1000,
                pinSizeY: (config?.pinSizeY ?? 1.4) / 1000,
                pinPitch: (config?.pinPitch ?? 2.54) / 1000,
                packageWidth: (config?.packageWidth ?? 10.0) / 1000,
                packageDepth: (config?.packageDepth ?? 4.5) / 1000,
                holeDiameter: (config?.holeDiameter ?? 1.0) / 1000,
                isSMD: config?.isSMD ?? false,
            }, existingPadNodes);
        },
        generatePadRules: (footprintNodeUid, bakedRules) => toGeneratePadRules(footprintNodeUid, bakedRules, { isSMD: false, holeDiameter: 1.0 / 1000 }),
        generateAdditionalPads: toGenerateAdditionalPads,
        generateSilkNodes: toGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    "TO-252": {
        computeInferredRules: (br, existingPadNodes) => {
            const config = getToConfig("TO-252");
            return toComputeInferredRules(br, {
                packageHeight: (config?.packageHeight ?? 6.1) / 1000,
                pinSizeX: (config?.pinSizeX ?? 0.9) / 1000,
                pinSizeY: (config?.pinSizeY ?? 1.5) / 1000,
                pinPitch: (config?.pinPitch ?? 2.3) / 1000,
                packageWidth: (config?.packageWidth ?? 6.5) / 1000,
                packageDepth: (config?.packageDepth ?? 2.3) / 1000,
                holeDiameter: 0,
                isSMD: config?.isSMD ?? true,
            }, existingPadNodes);
        },
        generatePadRules: (footprintNodeUid, bakedRules) => toGeneratePadRules(footprintNodeUid, bakedRules, { isSMD: true, holeDiameter: 0 }),
        generateAdditionalPads: toGenerateAdditionalPads,
        generateSilkNodes: toGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    DPAK: {
        computeInferredRules: (br, existingPadNodes) => {
            const config = getToConfig("TO-252");
            return toComputeInferredRules(br, {
                packageHeight: (config?.packageHeight ?? 6.1) / 1000,
                pinSizeX: (config?.pinSizeX ?? 0.9) / 1000,
                pinSizeY: (config?.pinSizeY ?? 1.5) / 1000,
                pinPitch: (config?.pinPitch ?? 2.3) / 1000,
                packageWidth: (config?.packageWidth ?? 6.5) / 1000,
                packageDepth: (config?.packageDepth ?? 2.3) / 1000,
                holeDiameter: 0,
                isSMD: config?.isSMD ?? true,
            }, existingPadNodes);
        },
        generatePadRules: (footprintNodeUid, bakedRules) => toGeneratePadRules(footprintNodeUid, bakedRules, { isSMD: true, holeDiameter: 0 }),
        generateAdditionalPads: toGenerateAdditionalPads,
        generateSilkNodes: toGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    "TO-263": {
        computeInferredRules: (br, existingPadNodes) => {
            const config = getToConfig("TO-263");
            return toComputeInferredRules(br, {
                packageHeight: (config?.packageHeight ?? 8.9) / 1000,
                pinSizeX: (config?.pinSizeX ?? 1.0) / 1000,
                pinSizeY: (config?.pinSizeY ?? 2.0) / 1000,
                pinPitch: (config?.pinPitch ?? 2.54) / 1000,
                packageWidth: (config?.packageWidth ?? 10.0) / 1000,
                packageDepth: (config?.packageDepth ?? 4.6) / 1000,
                holeDiameter: 0,
                isSMD: config?.isSMD ?? true,
            }, existingPadNodes);
        },
        generatePadRules: (footprintNodeUid, bakedRules) => toGeneratePadRules(footprintNodeUid, bakedRules, { isSMD: true, holeDiameter: 0 }),
        generateAdditionalPads: toGenerateAdditionalPads,
        generateSilkNodes: toGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    D2PAK: {
        computeInferredRules: (br, existingPadNodes) => {
            const config = getToConfig("TO-263");
            return toComputeInferredRules(br, {
                packageHeight: (config?.packageHeight ?? 8.9) / 1000,
                pinSizeX: (config?.pinSizeX ?? 1.0) / 1000,
                pinSizeY: (config?.pinSizeY ?? 2.0) / 1000,
                pinPitch: (config?.pinPitch ?? 2.54) / 1000,
                packageWidth: (config?.packageWidth ?? 10.0) / 1000,
                packageDepth: (config?.packageDepth ?? 4.6) / 1000,
                holeDiameter: 0,
                isSMD: config?.isSMD ?? true,
            }, existingPadNodes);
        },
        generatePadRules: (footprintNodeUid, bakedRules) => toGeneratePadRules(footprintNodeUid, bakedRules, { isSMD: true, holeDiameter: 0 }),
        generateAdditionalPads: toGenerateAdditionalPads,
        generateSilkNodes: toGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // SOT packages
    "SOT-23": {
        computeInferredRules: (br, existingPadNodes) => {
            const config = getSotConfig("SOT-23");
            return sotComputeInferredRules(br, {
                packageHeight: (config?.packageDepth ?? 1.0) / 1000,
                pinSizeX: (config?.pinSizeX ?? 0.6) / 1000,
                pinSizeY: (config?.pinSizeY ?? 1.0) / 1000,
                pinPitch: (config?.pinPitch ?? 0.95) / 1000,
                packageWidth: (config?.packageWidth ?? 2.9) / 1000,
                packageDepth: (config?.packageHeight ?? 1.3) / 1000,
                rowSpacing: (config?.rowSpacing ?? 2.4) / 1000,
                pinsPerSide: config?.pinsPerSide ?? [2, 1],
                padOuterMargin: 0.3 / 1000,
            }, existingPadNodes);
        },
        generatePadRules: (footprintNodeUid, bakedRules) => sotGeneratePadRules(footprintNodeUid, bakedRules, [2, 1]),
        generateAdditionalPads: sotGenerateAdditionalPads,
        generateSilkNodes: (footprintNodeUid, bakedRules) => sotGenerateSilkNodes(footprintNodeUid, bakedRules, [2, 1]),
        generate3DModelNode: commonGenerate3DModelNode,
    },
    "SOT-23-5": {
        computeInferredRules: (br, existingPadNodes) => {
            const config = getSotConfig("SOT-23-5");
            return sotComputeInferredRules(br, {
                packageHeight: (config?.packageDepth ?? 1.0) / 1000,
                pinSizeX: (config?.pinSizeX ?? 0.6) / 1000,
                pinSizeY: (config?.pinSizeY ?? 1.0) / 1000,
                pinPitch: (config?.pinPitch ?? 0.95) / 1000,
                packageWidth: (config?.packageWidth ?? 2.9) / 1000,
                packageDepth: (config?.packageHeight ?? 1.6) / 1000,
                rowSpacing: (config?.rowSpacing ?? 2.4) / 1000,
                pinsPerSide: config?.pinsPerSide ?? [3, 2],
                padOuterMargin: 0.3 / 1000,
            }, existingPadNodes);
        },
        generatePadRules: (footprintNodeUid, bakedRules) => sotGeneratePadRules(footprintNodeUid, bakedRules, [3, 2]),
        generateAdditionalPads: sotGenerateAdditionalPads,
        generateSilkNodes: (footprintNodeUid, bakedRules) => sotGenerateSilkNodes(footprintNodeUid, bakedRules, [3, 2]),
        generate3DModelNode: commonGenerate3DModelNode,
    },
    "SOT-23-6": {
        computeInferredRules: (br, existingPadNodes) => {
            const config = getSotConfig("SOT-23-6");
            return sotComputeInferredRules(br, {
                packageHeight: (config?.packageDepth ?? 1.0) / 1000,
                pinSizeX: (config?.pinSizeX ?? 0.6) / 1000,
                pinSizeY: (config?.pinSizeY ?? 1.0) / 1000,
                pinPitch: (config?.pinPitch ?? 0.95) / 1000,
                packageWidth: (config?.packageWidth ?? 2.9) / 1000,
                packageDepth: (config?.packageHeight ?? 1.6) / 1000,
                rowSpacing: (config?.rowSpacing ?? 2.4) / 1000,
                pinsPerSide: config?.pinsPerSide ?? [3, 3],
                padOuterMargin: 0.3 / 1000,
            }, existingPadNodes);
        },
        generatePadRules: (footprintNodeUid, bakedRules) => sotGeneratePadRules(footprintNodeUid, bakedRules, [3, 3]),
        generateAdditionalPads: sotGenerateAdditionalPads,
        generateSilkNodes: (footprintNodeUid, bakedRules) => sotGenerateSilkNodes(footprintNodeUid, bakedRules, [3, 3]),
        generate3DModelNode: commonGenerate3DModelNode,
    },
    "SOT-89": {
        computeInferredRules: (br, existingPadNodes) => {
            const config = getSotConfig("SOT-89");
            return sotComputeInferredRules(br, {
                packageHeight: (config?.packageDepth ?? 1.5) / 1000,
                pinSizeX: (config?.pinSizeX ?? 0.7) / 1000,
                pinSizeY: (config?.pinSizeY ?? 1.5) / 1000,
                pinPitch: (config?.pinPitch ?? 1.5) / 1000,
                packageWidth: (config?.packageWidth ?? 4.5) / 1000,
                packageDepth: (config?.packageHeight ?? 2.5) / 1000,
                rowSpacing: (config?.rowSpacing ?? 3.5) / 1000,
                pinsPerSide: config?.pinsPerSide ?? [3, 0],
                padOuterMargin: 0.3 / 1000,
            }, existingPadNodes);
        },
        generatePadRules: (footprintNodeUid, bakedRules) => sotGeneratePadRules(footprintNodeUid, bakedRules, [3, 0]),
        generateAdditionalPads: sotGenerateAdditionalPads,
        generateSilkNodes: (footprintNodeUid, bakedRules) => sotGenerateSilkNodes(footprintNodeUid, bakedRules, [3, 0]),
        generate3DModelNode: commonGenerate3DModelNode,
    },
    "SOT-223": {
        computeInferredRules: (br, existingPadNodes) => {
            const config = getSotConfig("SOT-223");
            return sotComputeInferredRules(br, {
                packageHeight: (config?.packageDepth ?? 1.6) / 1000,
                pinSizeX: (config?.pinSizeX ?? 0.9) / 1000,
                pinSizeY: (config?.pinSizeY ?? 1.5) / 1000,
                pinPitch: (config?.pinPitch ?? 2.3) / 1000,
                packageWidth: (config?.packageWidth ?? 6.5) / 1000,
                packageDepth: (config?.packageHeight ?? 3.5) / 1000,
                rowSpacing: (config?.rowSpacing ?? 6.5) / 1000,
                pinsPerSide: config?.pinsPerSide ?? [3, 1],
                padOuterMargin: 0.3 / 1000,
            }, existingPadNodes);
        },
        generatePadRules: (footprintNodeUid, bakedRules) => {
            const config = getSotConfig("SOT-223");
            // SOT-223 has a thermal tab on side 1 (Pin 4)
            const thermalTabConfig = {
                tabSizeX: (config?.tabSizeX ?? 3.0) / 1000,
                tabSizeY: (config?.tabSizeY ?? 2.0) / 1000,
            };
            return sotGeneratePadRules(footprintNodeUid, bakedRules, [3, 1], thermalTabConfig);
        },
        generateAdditionalPads: sotGenerateAdditionalPads,
        generateSilkNodes: (footprintNodeUid, bakedRules) => sotGenerateSilkNodes(footprintNodeUid, bakedRules, [3, 1]),
        generate3DModelNode: commonGenerate3DModelNode,
    },
    "TSOT-23": {
        computeInferredRules: (br, existingPadNodes) => {
            const config = getSotConfig("TSOT-23");
            return sotComputeInferredRules(br, {
                packageHeight: (config?.packageDepth ?? 0.9) / 1000,
                pinSizeX: (config?.pinSizeX ?? 0.4) / 1000,
                pinSizeY: (config?.pinSizeY ?? 0.6) / 1000,
                pinPitch: (config?.pinPitch ?? 0.65) / 1000,
                packageWidth: (config?.packageWidth ?? 2.1) / 1000,
                packageDepth: (config?.packageHeight ?? 1.25) / 1000,
                rowSpacing: (config?.rowSpacing ?? 1.8) / 1000,
                pinsPerSide: config?.pinsPerSide ?? [2, 1],
                padOuterMargin: 0.3 / 1000,
            }, existingPadNodes);
        },
        generatePadRules: (footprintNodeUid, bakedRules) => sotGeneratePadRules(footprintNodeUid, bakedRules, [2, 1]),
        generateAdditionalPads: sotGenerateAdditionalPads,
        generateSilkNodes: (footprintNodeUid, bakedRules) => sotGenerateSilkNodes(footprintNodeUid, bakedRules, [2, 1]),
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Additional SOT variants
    "SOT-23-8": {
        computeInferredRules: (br, existingPadNodes) => sotComputeInferredRules(br, {
            packageHeight: 1.0 / 1000,
            pinSizeX: 0.4 / 1000,
            pinSizeY: 0.8 / 1000,
            pinPitch: 0.65 / 1000,
            packageWidth: 2.9 / 1000,
            packageDepth: 1.6 / 1000,
            rowSpacing: 2.4 / 1000,
            pinsPerSide: [4, 4],
            padOuterMargin: 0.3 / 1000,
        }, existingPadNodes),
        generatePadRules: (footprintNodeUid, bakedRules) => sotGeneratePadRules(footprintNodeUid, bakedRules, [4, 4]),
        generateAdditionalPads: sotGenerateAdditionalPads,
        generateSilkNodes: (footprintNodeUid, bakedRules) => sotGenerateSilkNodes(footprintNodeUid, bakedRules, [4, 4]),
        generate3DModelNode: commonGenerate3DModelNode,
    },
    "SOT-323": {
        computeInferredRules: (br, existingPadNodes) => sotComputeInferredRules(br, {
            packageHeight: 0.9 / 1000,
            pinSizeX: 0.4 / 1000,
            pinSizeY: 0.6 / 1000,
            pinPitch: 0.65 / 1000,
            packageWidth: 2.0 / 1000,
            packageDepth: 1.25 / 1000,
            rowSpacing: 1.8 / 1000,
            pinsPerSide: [2, 1],
            padOuterMargin: 0.3 / 1000,
        }, existingPadNodes),
        generatePadRules: (footprintNodeUid, bakedRules) => sotGeneratePadRules(footprintNodeUid, bakedRules, [2, 1]),
        generateAdditionalPads: sotGenerateAdditionalPads,
        generateSilkNodes: (footprintNodeUid, bakedRules) => sotGenerateSilkNodes(footprintNodeUid, bakedRules, [2, 1]),
        generate3DModelNode: commonGenerate3DModelNode,
    },
    "SOT-363": {
        computeInferredRules: (br, existingPadNodes) => sotComputeInferredRules(br, {
            packageHeight: 0.9 / 1000,
            pinSizeX: 0.3 / 1000,
            pinSizeY: 0.5 / 1000,
            pinPitch: 0.65 / 1000,
            packageWidth: 2.0 / 1000,
            packageDepth: 1.25 / 1000,
            rowSpacing: 1.8 / 1000,
            pinsPerSide: [3, 3],
            padOuterMargin: 0.3 / 1000,
        }, existingPadNodes),
        generatePadRules: (footprintNodeUid, bakedRules) => sotGeneratePadRules(footprintNodeUid, bakedRules, [3, 3]),
        generateAdditionalPads: sotGenerateAdditionalPads,
        generateSilkNodes: (footprintNodeUid, bakedRules) => sotGenerateSilkNodes(footprintNodeUid, bakedRules, [3, 3]),
        generate3DModelNode: commonGenerate3DModelNode,
    },
    "SOT-143": {
        computeInferredRules: (br, existingPadNodes) => sotComputeInferredRules(br, {
            packageHeight: 1.0 / 1000,
            pinSizeX: 0.6 / 1000,
            pinSizeY: 1.0 / 1000,
            pinPitch: 0.95 / 1000,
            packageWidth: 2.9 / 1000,
            packageDepth: 1.3 / 1000,
            rowSpacing: 2.4 / 1000,
            pinsPerSide: [2, 2],
            padOuterMargin: 0.3 / 1000,
        }, existingPadNodes),
        generatePadRules: (footprintNodeUid, bakedRules) => sotGeneratePadRules(footprintNodeUid, bakedRules, [2, 2]),
        generateAdditionalPads: sotGenerateAdditionalPads,
        generateSilkNodes: (footprintNodeUid, bakedRules) => sotGenerateSilkNodes(footprintNodeUid, bakedRules, [2, 2]),
        generate3DModelNode: commonGenerate3DModelNode,
    },
    "SC-70": {
        computeInferredRules: (br, existingPadNodes) => sotComputeInferredRules(br, {
            packageHeight: 0.8 / 1000,
            pinSizeX: 0.3 / 1000,
            pinSizeY: 0.5 / 1000,
            pinPitch: 0.65 / 1000,
            packageWidth: 2.0 / 1000,
            packageDepth: 1.25 / 1000,
            rowSpacing: 1.8 / 1000,
            pinsPerSide: [2, 1],
            padOuterMargin: 0.3 / 1000,
        }, existingPadNodes),
        generatePadRules: (footprintNodeUid, bakedRules) => sotGeneratePadRules(footprintNodeUid, bakedRules, [2, 1]),
        generateAdditionalPads: sotGenerateAdditionalPads,
        generateSilkNodes: (footprintNodeUid, bakedRules) => sotGenerateSilkNodes(footprintNodeUid, bakedRules, [2, 1]),
        generate3DModelNode: commonGenerate3DModelNode,
    },
    "SOT-416": {
        computeInferredRules: (br, existingPadNodes) => sotComputeInferredRules(br, {
            packageHeight: 0.6 / 1000,
            pinSizeX: 0.25 / 1000,
            pinSizeY: 0.4 / 1000,
            pinPitch: 0.5 / 1000,
            packageWidth: 1.6 / 1000,
            packageDepth: 0.8 / 1000,
            rowSpacing: 1.2 / 1000,
            pinsPerSide: [2, 1],
            padOuterMargin: 0.3 / 1000,
        }, existingPadNodes),
        generatePadRules: (footprintNodeUid, bakedRules) => sotGeneratePadRules(footprintNodeUid, bakedRules, [2, 1]),
        generateAdditionalPads: sotGenerateAdditionalPads,
        generateSilkNodes: (footprintNodeUid, bakedRules) => sotGenerateSilkNodes(footprintNodeUid, bakedRules, [2, 1]),
        generate3DModelNode: commonGenerate3DModelNode,
    },
    "SOT-666": {
        computeInferredRules: (br, existingPadNodes) => sotComputeInferredRules(br, {
            packageHeight: 0.5 / 1000,
            pinSizeX: 0.2 / 1000,
            pinSizeY: 0.35 / 1000,
            pinPitch: 0.5 / 1000,
            packageWidth: 1.6 / 1000,
            packageDepth: 1.0 / 1000,
            rowSpacing: 1.2 / 1000,
            pinsPerSide: [3, 3],
            padOuterMargin: 0.3 / 1000,
        }, existingPadNodes),
        generatePadRules: (footprintNodeUid, bakedRules) => sotGeneratePadRules(footprintNodeUid, bakedRules, [3, 3]),
        generateAdditionalPads: sotGenerateAdditionalPads,
        generateSilkNodes: (footprintNodeUid, bakedRules) => sotGenerateSilkNodes(footprintNodeUid, bakedRules, [3, 3]),
        generate3DModelNode: commonGenerate3DModelNode,
    },
    "SOT-723": {
        computeInferredRules: (br, existingPadNodes) => sotComputeInferredRules(br, {
            packageHeight: 0.5 / 1000,
            pinSizeX: 0.2 / 1000,
            pinSizeY: 0.3 / 1000,
            pinPitch: 0.4 / 1000,
            packageWidth: 1.2 / 1000,
            packageDepth: 0.8 / 1000,
            rowSpacing: 1.0 / 1000,
            pinsPerSide: [2, 1],
            padOuterMargin: 0.3 / 1000,
        }, existingPadNodes),
        generatePadRules: (footprintNodeUid, bakedRules) => sotGeneratePadRules(footprintNodeUid, bakedRules, [2, 1]),
        generateAdditionalPads: sotGenerateAdditionalPads,
        generateSilkNodes: (footprintNodeUid, bakedRules) => sotGenerateSilkNodes(footprintNodeUid, bakedRules, [2, 1]),
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // HTSSOP - Heat-sink Thin Shrink Small Outline Package (uses TSSOP generator with exposed pad)
    HTSSOP: {
        computeInferredRules: (br, existingPadNodes) => tssopComputeInferredRules(br, {
            packageHeight: 1.1 / 1000, // Slightly taller for heat sink
            pinSizeX: 0.3 / 1000,
            pinSizeY: 0.8 / 1000,
            pinPitch: 0.65 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: tssopGeneratePadRules,
        generateAdditionalPads: tssopGenerateAdditionalPads,
        generateSilkNodes: tssopGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // ETSSOP - Exposed pad TSSOP
    ETSSOP: {
        computeInferredRules: (br, existingPadNodes) => tssopComputeInferredRules(br, {
            packageHeight: 1.0 / 1000,
            pinSizeX: 0.3 / 1000,
            pinSizeY: 0.8 / 1000,
            pinPitch: 0.65 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: tssopGeneratePadRules,
        generateAdditionalPads: tssopGenerateAdditionalPads,
        generateSilkNodes: tssopGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // HTQFP - Heat-sink Thin Quad Flat Package
    HTQFP: {
        computeInferredRules: (br, existingPadNodes) => lqfpComputeInferredRules(br, {
            packageHeight: 1.2 / 1000,
            pinSizeX: 0.25 / 1000,
            pinSizeY: 0.8 / 1000,
            pinPitch: 0.5 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: lqfpGeneratePadRules,
        generateAdditionalPads: lqfpGenerateAdditionalPads,
        generateSilkNodes: lqfpGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // EQFP - Enhanced Quad Flat Package
    EQFP: {
        computeInferredRules: (br, existingPadNodes) => lqfpComputeInferredRules(br, {
            packageHeight: 2.0 / 1000,
            pinSizeX: 0.3 / 1000,
            pinSizeY: 1.0 / 1000,
            pinPitch: 0.5 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: lqfpGeneratePadRules,
        generateAdditionalPads: lqfpGenerateAdditionalPads,
        generateSilkNodes: lqfpGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // HLQFP - Heat-sink Low-profile Quad Flat Package
    HLQFP: {
        computeInferredRules: (br, existingPadNodes) => lqfpComputeInferredRules(br, {
            packageHeight: 1.4 / 1000,
            pinSizeX: 0.3 / 1000,
            pinSizeY: 1.0 / 1000,
            pinPitch: 0.5 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: lqfpGeneratePadRules,
        generateAdditionalPads: lqfpGenerateAdditionalPads,
        generateSilkNodes: lqfpGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // SOJ - Small Outline J-lead (uses SOIC-like generator)
    SOJ: {
        computeInferredRules: (br, existingPadNodes) => soicComputeInferredRules(br, {
            packageHeight: 3.5 / 1000, // Taller for J-leads
            pinSizeX: 0.4 / 1000,
            pinSizeY: 1.5 / 1000, // Longer pads for J-leads
            pinPitch: 1.27 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: soicGeneratePadRules,
        generateAdditionalPads: soicGenerateAdditionalPads,
        generateSilkNodes: soicGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // VSOP - Very Small Outline Package
    VSOP: {
        computeInferredRules: (br, existingPadNodes) => ssopComputeInferredRules(br, {
            packageHeight: 1.0 / 1000,
            pinSizeX: 0.2 / 1000,
            pinSizeY: 0.6 / 1000,
            pinPitch: 0.4 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: ssopGeneratePadRules,
        generateAdditionalPads: ssopGenerateAdditionalPads,
        generateSilkNodes: ssopGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // VSO - Very Small Outline
    VSO: {
        computeInferredRules: (br, existingPadNodes) => ssopComputeInferredRules(br, {
            packageHeight: 1.2 / 1000,
            pinSizeX: 0.25 / 1000,
            pinSizeY: 0.7 / 1000,
            pinPitch: 0.5 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: ssopGeneratePadRules,
        generateAdditionalPads: ssopGenerateAdditionalPads,
        generateSilkNodes: ssopGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // MLPQ - Micro Lead Frame Package Quad (similar to QFN)
    MLPQ: {
        computeInferredRules: (br, existingPadNodes) => qfnComputeInferredRules(br, {
            packageHeight: 0.9 / 1000,
            pinSizeX: 0.25 / 1000,
            pinSizeY: 0.4 / 1000,
            pinPitch: 0.5 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: qfnGeneratePadRules,
        generateAdditionalPads: qfnGenerateAdditionalPads,
        generateSilkNodes: qfnGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // MLF - Micro Lead Frame (similar to QFN)
    MLF: {
        computeInferredRules: (br, existingPadNodes) => qfnComputeInferredRules(br, {
            packageHeight: 0.85 / 1000,
            pinSizeX: 0.25 / 1000,
            pinSizeY: 0.4 / 1000,
            pinPitch: 0.5 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: qfnGeneratePadRules,
        generateAdditionalPads: qfnGenerateAdditionalPads,
        generateSilkNodes: qfnGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // LFCSP - Lead Frame Chip Scale Package (similar to QFN)
    LFCSP: {
        computeInferredRules: (br, existingPadNodes) => qfnComputeInferredRules(br, {
            packageHeight: 0.75 / 1000,
            pinSizeX: 0.25 / 1000,
            pinSizeY: 0.35 / 1000,
            pinPitch: 0.5 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: qfnGeneratePadRules,
        generateAdditionalPads: qfnGenerateAdditionalPads,
        generateSilkNodes: qfnGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // FCCSP - Flip Chip Chip Scale Package (similar to CSP/BGA)
    FCCSP: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 0.5 / 1000,
            pinSize: 0.2 / 1000,
            pinPitch: 0.4 / 1000,
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Additional BGA variants
    // FPBGA - Fine Pitch Ball Grid Array
    FPBGA: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 1.4 / 1000,
            pinSize: 0.35 / 1000,
            pinPitch: 0.65 / 1000,
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // FTBGA - Fine Pitch Thin Ball Grid Array
    FTBGA: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 0.8 / 1000,
            pinSize: 0.3 / 1000,
            pinPitch: 0.5 / 1000,
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // CSFBGA - Chip Scale Fine Ball Grid Array
    CSFBGA: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 0.6 / 1000,
            pinSize: 0.25 / 1000,
            pinPitch: 0.5 / 1000,
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // LBGA - Low-profile Ball Grid Array
    LBGA: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 1.0 / 1000,
            pinSize: 0.4 / 1000,
            pinPitch: 0.8 / 1000,
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // VBGA - Very thin Ball Grid Array
    VBGA: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 0.7 / 1000,
            pinSize: 0.35 / 1000,
            pinPitch: 0.65 / 1000,
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // MBGA - Micro Ball Grid Array
    MBGA: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 0.5 / 1000,
            pinSize: 0.2 / 1000,
            pinPitch: 0.4 / 1000,
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // CSPBGA - Chip Scale Package Ball Grid Array
    CSPBGA: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 0.6 / 1000,
            pinSize: 0.25 / 1000,
            pinPitch: 0.5 / 1000,
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // CSBGA - Chip Scale Ball Grid Array
    CSBGA: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 0.55 / 1000,
            pinSize: 0.22 / 1000,
            pinPitch: 0.45 / 1000,
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // USP - Ultra Small Package (uses SOT-like generator)
    USP: {
        computeInferredRules: (br, existingPadNodes) => sotComputeInferredRules(br, {
            packageHeight: 0.5 / 1000,
            pinSizeX: 0.2 / 1000,
            pinSizeY: 0.3 / 1000,
            pinPitch: 0.5 / 1000,
            packageWidth: 1.0 / 1000,
            packageDepth: 0.6 / 1000,
            rowSpacing: 0.8 / 1000,
            pinsPerSide: [2, 1],
            padOuterMargin: 0.2 / 1000,
        }, existingPadNodes),
        generatePadRules: (footprintNodeUid, bakedRules) => sotGeneratePadRules(footprintNodeUid, bakedRules, [2, 1]),
        generateAdditionalPads: sotGenerateAdditionalPads,
        generateSilkNodes: (footprintNodeUid, bakedRules) => sotGenerateSilkNodes(footprintNodeUid, bakedRules, [2, 1]),
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // SO - Small Outline (generic, uses SOIC generator)
    SO: {
        computeInferredRules: (br, existingPadNodes) => soicComputeInferredRules(br, {
            packageHeight: 1.75 / 1000,
            pinSizeX: 0.4 / 1000,
            pinSizeY: 1.0 / 1000,
            pinPitch: 1.27 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: soicGeneratePadRules,
        generateAdditionalPads: soicGenerateAdditionalPads,
        generateSilkNodes: soicGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // SMDIP - Surface Mount Dual In-line Package
    SMDIP: {
        computeInferredRules: (br, existingPadNodes) => soicComputeInferredRules(br, {
            packageHeight: 3.0 / 1000,
            pinSizeX: 0.5 / 1000,
            pinSizeY: 1.5 / 1000,
            pinPitch: 2.54 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: soicGeneratePadRules,
        generateAdditionalPads: soicGenerateAdditionalPads,
        generateSilkNodes: soicGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // PowerSMD - Power Surface Mount Device (uses DFN-like generator for SMD power packages)
    PowerSMD: {
        computeInferredRules: (br, existingPadNodes) => dfnComputeInferredRules(br, {
            packageHeight: 2.3 / 1000,
            pinSizeX: 0.9 / 1000,
            pinSizeY: 1.5 / 1000,
            pinPitch: 1.27 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: dfnGeneratePadRules,
        generateAdditionalPads: dfnGenerateAdditionalPads,
        generateSilkNodes: dfnGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // POWERDI - Power Diode Package (uses chip generator for 2-pin packages)
    POWERDI: {
        computeInferredRules: (br, existingPadNodes) => chipComputeInferredRules(br, {
            packageHeight: 1.0 / 1000,
            pinSizeX: 0.8 / 1000,
            pinSizeY: 1.2 / 1000,
            padSpacing: 3.0 / 1000,
            packageLength: 4.0 / 1000,
            packageWidth: 2.5 / 1000,
        }, existingPadNodes),
        generatePadRules: chipGeneratePadRules,
        generateAdditionalPads: chipGenerateAdditionalPads,
        generateSilkNodes: chipGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // POWERDIP - Power Dual In-line Package
    POWERDIP: {
        computeInferredRules: (br, existingPadNodes) => dipComputeInferredRules(br, {
            packageHeight: 5.0 / 1000,
            pinSizeX: 1.6 / 1000,
            pinSizeY: 1.6 / 1000,
            pinPitch: 2.54 / 1000,
            rowSpacing: 7.62 / 1000,
            holeDiameter: 1.0 / 1000,
        }, existingPadNodes),
        generatePadRules: dipGeneratePadRules,
        generateAdditionalPads: dipGenerateAdditionalPads,
        generateSilkNodes: dipGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // POWERVDFN - Power Very Thin Dual Flat No-lead
    POWERVDFN: {
        computeInferredRules: (br, existingPadNodes) => dfnComputeInferredRules(br, {
            packageHeight: 1.0 / 1000,
            pinSizeX: 0.4 / 1000,
            pinSizeY: 0.8 / 1000,
            pinPitch: 0.65 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: dfnGeneratePadRules,
        generateAdditionalPads: dfnGenerateAdditionalPads,
        generateSilkNodes: dfnGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // DO - Diode Outline (2-pin diode package, uses chip generator)
    DO: {
        computeInferredRules: (br, existingPadNodes) => chipComputeInferredRules(br, {
            packageHeight: 2.0 / 1000,
            pinSizeX: 1.0 / 1000,
            pinSizeY: 1.5 / 1000,
            padSpacing: 3.5 / 1000,
            packageLength: 5.0 / 1000,
            packageWidth: 2.5 / 1000,
        }, existingPadNodes),
        generatePadRules: chipGeneratePadRules,
        generateAdditionalPads: chipGenerateAdditionalPads,
        generateSilkNodes: chipGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // SOD - Small Outline Diode
    SOD: {
        computeInferredRules: (br, existingPadNodes) => chipComputeInferredRules(br, {
            packageHeight: 1.0 / 1000,
            pinSizeX: 0.5 / 1000,
            pinSizeY: 0.6 / 1000,
            padSpacing: 2.0 / 1000,
            packageLength: 2.7 / 1000,
            packageWidth: 1.3 / 1000,
        }, existingPadNodes),
        generatePadRules: chipGeneratePadRules,
        generateAdditionalPads: chipGenerateAdditionalPads,
        generateSilkNodes: chipGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // MELF - Metal Electrode Leadless Face (cylindrical package)
    MELF: {
        computeInferredRules: (br, existingPadNodes) => chipComputeInferredRules(br, {
            packageHeight: 2.2 / 1000, // Cylindrical, so height = diameter
            pinSizeX: 0.8 / 1000,
            pinSizeY: 2.2 / 1000, // Match diameter
            padSpacing: 4.0 / 1000,
            packageLength: 5.0 / 1000,
            packageWidth: 2.2 / 1000,
        }, existingPadNodes),
        generatePadRules: chipGeneratePadRules,
        generateAdditionalPads: chipGenerateAdditionalPads,
        generateSilkNodes: chipGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // SMC - Surface Mount Component (diode package)
    SMC: {
        computeInferredRules: (br, existingPadNodes) => chipComputeInferredRules(br, {
            packageHeight: 2.5 / 1000,
            pinSizeX: 1.5 / 1000,
            pinSizeY: 3.0 / 1000,
            padSpacing: 6.0 / 1000,
            packageLength: 7.9 / 1000,
            packageWidth: 5.9 / 1000,
        }, existingPadNodes),
        generatePadRules: chipGeneratePadRules,
        generateAdditionalPads: chipGenerateAdditionalPads,
        generateSilkNodes: chipGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // P600 - Power diode package
    P600: {
        computeInferredRules: (br, existingPadNodes) => chipComputeInferredRules(br, {
            packageHeight: 8.0 / 1000,
            pinSizeX: 2.0 / 1000,
            pinSizeY: 2.0 / 1000,
            padSpacing: 10.0 / 1000,
            packageLength: 15.0 / 1000,
            packageWidth: 8.0 / 1000,
        }, existingPadNodes),
        generatePadRules: chipGeneratePadRules,
        generateAdditionalPads: chipGenerateAdditionalPads,
        generateSilkNodes: chipGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // SSOT - Shrink Small Outline Transistor
    SSOT: {
        computeInferredRules: (br, existingPadNodes) => sotComputeInferredRules(br, {
            packageHeight: 0.9 / 1000,
            pinSizeX: 0.4 / 1000,
            pinSizeY: 0.6 / 1000,
            pinPitch: 0.65 / 1000,
            packageWidth: 2.0 / 1000,
            packageDepth: 1.25 / 1000,
            rowSpacing: 1.8 / 1000,
            pinsPerSide: [3, 3],
            padOuterMargin: 0.3 / 1000,
        }, existingPadNodes),
        generatePadRules: (footprintNodeUid, bakedRules) => sotGeneratePadRules(footprintNodeUid, bakedRules, [3, 3]),
        generateAdditionalPads: sotGenerateAdditionalPads,
        generateSilkNodes: (footprintNodeUid, bakedRules) => sotGenerateSilkNodes(footprintNodeUid, bakedRules, [3, 3]),
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // CSMD - Chip Surface Mount Device
    CSMD: {
        computeInferredRules: (br, existingPadNodes) => chipComputeInferredRules(br, {
            packageHeight: 0.5 / 1000,
            pinSizeX: 0.3 / 1000,
            pinSizeY: 0.5 / 1000,
            padSpacing: 1.0 / 1000,
            packageLength: 1.6 / 1000,
            packageWidth: 0.8 / 1000,
        }, existingPadNodes),
        generatePadRules: chipGeneratePadRules,
        generateAdditionalPads: chipGenerateAdditionalPads,
        generateSilkNodes: chipGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // PLAD - Plastic Leaded Array Device (similar to PLCC)
    PLAD: {
        computeInferredRules: (br, existingPadNodes) => qfnComputeInferredRules(br, {
            packageHeight: 3.0 / 1000,
            pinSizeX: 0.5 / 1000,
            pinSizeY: 1.5 / 1000,
            pinPitch: 1.27 / 1000,
            padOuterMargin: 0.25 / 1000,
        }, existingPadNodes),
        generatePadRules: qfnGeneratePadRules,
        generateAdditionalPads: qfnGenerateAdditionalPads,
        generateSilkNodes: qfnGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // FLIPCHIP - Flip Chip package (similar to BGA)
    FLIPCHIP: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 0.4 / 1000,
            pinSize: 0.15 / 1000,
            pinPitch: 0.3 / 1000,
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // BPX - Ball Pin X-array (similar to BGA)
    BPX: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: 1.0 / 1000,
            pinSize: 0.35 / 1000,
            pinPitch: 0.65 / 1000,
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // SOT - Generic Small Outline Transistor (base family) - uses SSOP generator for 2-sided packages
    SOT: {
        computeInferredRules: (br, existingPadNodes) => ssopComputeInferredRules(br, {
            packageHeight: mmToMeters(1.0),
            pinSizeX: mmToMeters(0.6),
            pinSizeY: mmToMeters(1.0),
            pinPitch: mmToMeters(0.95),
            padOuterMargin: mmToMeters(0.3),
        }, existingPadNodes),
        generatePadRules: ssopGeneratePadRules,
        generateAdditionalPads: ssopGenerateAdditionalPads,
        generateSilkNodes: ssopGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // TO - Generic Transistor Outline (base family) - uses DFN generator for SMD packages
    TO: {
        computeInferredRules: (br, existingPadNodes) => dfnComputeInferredRules(br, {
            packageHeight: mmToMeters(4.5),
            pinSizeX: mmToMeters(1.4),
            pinSizeY: mmToMeters(1.4),
            pinPitch: mmToMeters(2.54),
            padOuterMargin: mmToMeters(0.25),
        }, existingPadNodes),
        generatePadRules: dfnGeneratePadRules,
        generateAdditionalPads: dfnGenerateAdditionalPads,
        generateSilkNodes: dfnGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // TSOT - Generic Thin Small Outline Transistor (base family) - uses SSOP generator
    TSOT: {
        computeInferredRules: (br, existingPadNodes) => ssopComputeInferredRules(br, {
            packageHeight: mmToMeters(0.9),
            pinSizeX: mmToMeters(0.4),
            pinSizeY: mmToMeters(0.6),
            pinPitch: mmToMeters(0.65),
            padOuterMargin: mmToMeters(0.25),
        }, existingPadNodes),
        generatePadRules: ssopGeneratePadRules,
        generateAdditionalPads: ssopGenerateAdditionalPads,
        generateSilkNodes: ssopGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // CP - Polarized Capacitor (tantalum/electrolytic SMD)
    CP: {
        computeInferredRules: (br, existingPadNodes) => chipComputeInferredRules(br, {
            packageHeight: mmToMeters(1.8),
            pinSizeX: mmToMeters(0.8),
            pinSizeY: mmToMeters(1.2),
            padSpacing: mmToMeters(2.4),
            packageLength: mmToMeters(3.2),
            packageWidth: mmToMeters(1.6),
        }, existingPadNodes),
        generatePadRules: chipGeneratePadRules,
        generateAdditionalPads: chipGenerateAdditionalPads,
        generateSilkNodes: chipGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // CPOL - Polarized Capacitor (electrolytic)
    CPOL: {
        computeInferredRules: (br, existingPadNodes) => chipComputeInferredRules(br, {
            packageHeight: mmToMeters(2.0),
            pinSizeX: mmToMeters(1.0),
            pinSizeY: mmToMeters(1.5),
            padSpacing: mmToMeters(3.0),
            packageLength: mmToMeters(4.0),
            packageWidth: mmToMeters(2.0),
        }, existingPadNodes),
        generatePadRules: chipGeneratePadRules,
        generateAdditionalPads: chipGenerateAdditionalPads,
        generateSilkNodes: chipGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // SMD - Generic Surface Mount Device
    SMD: {
        computeInferredRules: (br, existingPadNodes) => chipComputeInferredRules(br, {
            packageHeight: mmToMeters(0.5),
            pinSizeX: mmToMeters(0.5),
            pinSizeY: mmToMeters(0.5),
            padSpacing: mmToMeters(1.6),
            packageLength: mmToMeters(1.6),
            packageWidth: mmToMeters(0.8),
        }, existingPadNodes),
        generatePadRules: chipGeneratePadRules,
        generateAdditionalPads: chipGenerateAdditionalPads,
        generateSilkNodes: chipGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // TH - Generic Through-Hole package - uses DIP generator for proper through-hole pads
    TH: {
        computeInferredRules: (br, existingPadNodes) => dipComputeInferredRules(br, {
            packageHeight: mmToMeters(5.0),
            pinSizeX: mmToMeters(1.0),
            pinSizeY: mmToMeters(1.0),
            pinPitch: mmToMeters(2.54),
            rowSpacing: mmToMeters(7.62),
            holeDiameter: mmToMeters(0.8),
        }, existingPadNodes),
        generatePadRules: dipGeneratePadRules,
        generateAdditionalPads: dipGenerateAdditionalPads,
        generateSilkNodes: dipGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // R - Generic Resistor (chip resistor)
    R: {
        computeInferredRules: (br, existingPadNodes) => chipComputeInferredRules(br, {
            packageHeight: mmToMeters(0.45),
            pinSizeX: mmToMeters(0.4),
            pinSizeY: mmToMeters(0.5),
            padSpacing: mmToMeters(1.0),
            packageLength: mmToMeters(1.0),
            packageWidth: mmToMeters(0.5),
        }, existingPadNodes),
        generatePadRules: chipGeneratePadRules,
        generateAdditionalPads: chipGenerateAdditionalPads,
        generateSilkNodes: chipGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // C - Generic Capacitor (chip capacitor)
    C: {
        computeInferredRules: (br, existingPadNodes) => chipComputeInferredRules(br, {
            packageHeight: mmToMeters(0.5),
            pinSizeX: mmToMeters(0.5),
            pinSizeY: mmToMeters(0.5),
            padSpacing: mmToMeters(1.0),
            packageLength: mmToMeters(1.0),
            packageWidth: mmToMeters(0.5),
        }, existingPadNodes),
        generatePadRules: chipGeneratePadRules,
        generateAdditionalPads: chipGenerateAdditionalPads,
        generateSilkNodes: chipGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // L - Generic Inductor (chip inductor)
    L: {
        computeInferredRules: (br, existingPadNodes) => chipComputeInferredRules(br, {
            packageHeight: mmToMeters(0.8),
            pinSizeX: mmToMeters(0.5),
            pinSizeY: mmToMeters(0.5),
            padSpacing: mmToMeters(1.2),
            packageLength: mmToMeters(1.2),
            packageWidth: mmToMeters(0.6),
        }, existingPadNodes),
        generatePadRules: chipGeneratePadRules,
        generateAdditionalPads: chipGenerateAdditionalPads,
        generateSilkNodes: chipGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // D - Generic Diode (chip diode)
    D: {
        computeInferredRules: (br, existingPadNodes) => chipComputeInferredRules(br, {
            packageHeight: mmToMeters(0.6),
            pinSizeX: mmToMeters(0.5),
            pinSizeY: mmToMeters(0.5),
            padSpacing: mmToMeters(1.4),
            packageLength: mmToMeters(1.4),
            packageWidth: mmToMeters(0.6),
        }, existingPadNodes),
        generatePadRules: chipGeneratePadRules,
        generateAdditionalPads: chipGenerateAdditionalPads,
        generateSilkNodes: chipGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // MODULE - Generic Module package (uses grid array for flexibility)
    MODULE: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: mmToMeters(3.0),
            pinSize: mmToMeters(0.8),
            pinPitch: mmToMeters(2.54),
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // FPGA - FPGA package (uses grid array, typically BGA-based)
    FPGA: {
        computeInferredRules: (br, existingPadNodes) => gridArrayComputeInferredRules(br, {
            packageHeight: mmToMeters(2.5),
            pinSize: mmToMeters(0.5),
            pinPitch: mmToMeters(1.0),
        }, existingPadNodes),
        generatePadRules: gridArrayGeneratePadRules,
        generateAdditionalPads: () => [],
        generateSilkNodes: gridArrayGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // XCVR - Transceiver module package
    XCVR: {
        computeInferredRules: (br, existingPadNodes) => dfnComputeInferredRules(br, {
            packageHeight: mmToMeters(2.0),
            pinSizeX: mmToMeters(0.3),
            pinSizeY: mmToMeters(0.8),
            pinPitch: mmToMeters(0.5),
            padOuterMargin: mmToMeters(0.25),
        }, existingPadNodes),
        generatePadRules: dfnGeneratePadRules,
        generateAdditionalPads: dfnGenerateAdditionalPads,
        generateSilkNodes: dfnGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // CMWX - RF Transceiver module
    CMWX: {
        computeInferredRules: (br, existingPadNodes) => dfnComputeInferredRules(br, {
            packageHeight: mmToMeters(2.5),
            pinSizeX: mmToMeters(0.4),
            pinSizeY: mmToMeters(1.0),
            pinPitch: mmToMeters(0.65),
            padOuterMargin: mmToMeters(0.25),
        }, existingPadNodes),
        generatePadRules: dfnGeneratePadRules,
        generateAdditionalPads: dfnGenerateAdditionalPads,
        generateSilkNodes: dfnGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // DIN - DIN connector package - uses SSOP generator for SMD approximation
    DIN: {
        computeInferredRules: (br, existingPadNodes) => ssopComputeInferredRules(br, {
            packageHeight: mmToMeters(10.0),
            pinSizeX: mmToMeters(1.5),
            pinSizeY: mmToMeters(1.5),
            pinPitch: mmToMeters(2.54),
            padOuterMargin: mmToMeters(0.25),
        }, existingPadNodes),
        generatePadRules: ssopGeneratePadRules,
        generateAdditionalPads: ssopGenerateAdditionalPads,
        generateSilkNodes: ssopGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // USB - USB connector package
    USB: {
        computeInferredRules: (br, existingPadNodes) => dfnComputeInferredRules(br, {
            packageHeight: mmToMeters(3.0),
            pinSizeX: mmToMeters(0.4),
            pinSizeY: mmToMeters(1.5),
            pinPitch: mmToMeters(0.65),
            padOuterMargin: mmToMeters(0.25),
        }, existingPadNodes),
        generatePadRules: dfnGeneratePadRules,
        generateAdditionalPads: dfnGenerateAdditionalPads,
        generateSilkNodes: dfnGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // RHDR - Right-angle header connector - uses SSOP generator for SMD approximation
    RHDR: {
        computeInferredRules: (br, existingPadNodes) => ssopComputeInferredRules(br, {
            packageHeight: mmToMeters(8.5),
            pinSizeX: mmToMeters(1.0),
            pinSizeY: mmToMeters(1.0),
            pinPitch: mmToMeters(2.54),
            padOuterMargin: mmToMeters(0.25),
        }, existingPadNodes),
        generatePadRules: ssopGeneratePadRules,
        generateAdditionalPads: ssopGenerateAdditionalPads,
        generateSilkNodes: ssopGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // DISP - Display package (7-segment, LCD, etc.) - uses SSOP generator for SMD approximation
    DISP: {
        computeInferredRules: (br, existingPadNodes) => ssopComputeInferredRules(br, {
            packageHeight: mmToMeters(8.0),
            pinSizeX: mmToMeters(0.8),
            pinSizeY: mmToMeters(0.8),
            pinPitch: mmToMeters(2.54),
            padOuterMargin: mmToMeters(0.25),
        }, existingPadNodes),
        generatePadRules: ssopGeneratePadRules,
        generateAdditionalPads: ssopGenerateAdditionalPads,
        generateSilkNodes: ssopGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // SMD-Component family packages
    // RES-ARRAY-SMD - Resistor Array SMD (uses SSOP generator for multi-pin layout)
    "RES-ARRAY-SMD": {
        computeInferredRules: (br, existingPadNodes) => ssopComputeInferredRules(br, {
            packageHeight: mmToMeters(0.6),
            pinSizeX: mmToMeters(0.3),
            pinSizeY: mmToMeters(0.5),
            pinPitch: mmToMeters(0.5),
            padOuterMargin: mmToMeters(0.25),
        }, existingPadNodes),
        generatePadRules: ssopGeneratePadRules,
        generateAdditionalPads: ssopGenerateAdditionalPads,
        generateSilkNodes: ssopGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // RES-ADJ-SMD - Adjustable Resistor SMD (potentiometer, 3 pins)
    "RES-ADJ-SMD": {
        computeInferredRules: (br, existingPadNodes) => sotComputeInferredRules(br, {
            packageHeight: mmToMeters(2.0),
            pinSizeX: mmToMeters(0.8),
            pinSizeY: mmToMeters(1.0),
            pinPitch: mmToMeters(1.27),
            packageWidth: mmToMeters(4.0),
            packageDepth: mmToMeters(3.0),
            rowSpacing: mmToMeters(3.5),
            pinsPerSide: [2, 1],
            padOuterMargin: mmToMeters(0.25),
        }, existingPadNodes),
        generatePadRules: (footprintNodeUid, bakedRules) => sotGeneratePadRules(footprintNodeUid, bakedRules, [2, 1]),
        generateAdditionalPads: sotGenerateAdditionalPads,
        generateSilkNodes: (footprintNodeUid, bakedRules) => sotGenerateSilkNodes(footprintNodeUid, bakedRules, [2, 1]),
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // KEY-SMD - Keypad/Button SMD
    "KEY-SMD": {
        computeInferredRules: (br, existingPadNodes) => chipComputeInferredRules(br, {
            packageHeight: mmToMeters(1.5),
            pinSizeX: mmToMeters(1.0),
            pinSizeY: mmToMeters(1.0),
            padSpacing: mmToMeters(4.0),
            packageLength: mmToMeters(6.0),
            packageWidth: mmToMeters(3.5),
        }, existingPadNodes),
        generatePadRules: chipGeneratePadRules,
        generateAdditionalPads: chipGenerateAdditionalPads,
        generateSilkNodes: chipGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // SW-SMD - Switch SMD
    "SW-SMD": {
        computeInferredRules: (br, existingPadNodes) => chipComputeInferredRules(br, {
            packageHeight: mmToMeters(1.5),
            pinSizeX: mmToMeters(0.8),
            pinSizeY: mmToMeters(0.8),
            padSpacing: mmToMeters(3.5),
            packageLength: mmToMeters(4.5),
            packageWidth: mmToMeters(3.0),
        }, existingPadNodes),
        generatePadRules: chipGeneratePadRules,
        generateAdditionalPads: chipGenerateAdditionalPads,
        generateSilkNodes: chipGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // OSC-SMD - Oscillator SMD (4-pin)
    "OSC-SMD": {
        computeInferredRules: (br, existingPadNodes) => qfnComputeInferredRules(br, {
            packageHeight: mmToMeters(1.2),
            pinSizeX: mmToMeters(0.5),
            pinSizeY: mmToMeters(0.8),
            pinPitch: mmToMeters(2.5),
            padOuterMargin: mmToMeters(0.25),
        }, existingPadNodes),
        generatePadRules: qfnGeneratePadRules,
        generateAdditionalPads: qfnGenerateAdditionalPads,
        generateSilkNodes: qfnGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // CRYSTAL-SMD - Crystal SMD (2-pin)
    "CRYSTAL-SMD": {
        computeInferredRules: (br, existingPadNodes) => chipComputeInferredRules(br, {
            packageHeight: mmToMeters(0.7),
            pinSizeX: mmToMeters(0.6),
            pinSizeY: mmToMeters(0.8),
            padSpacing: mmToMeters(2.0),
            packageLength: mmToMeters(3.2),
            packageWidth: mmToMeters(1.5),
        }, existingPadNodes),
        generatePadRules: chipGeneratePadRules,
        generateAdditionalPads: chipGenerateAdditionalPads,
        generateSilkNodes: chipGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // CONN-SMD - Connector SMD
    "CONN-SMD": {
        computeInferredRules: (br, existingPadNodes) => ssopComputeInferredRules(br, {
            packageHeight: mmToMeters(3.0),
            pinSizeX: mmToMeters(0.5),
            pinSizeY: mmToMeters(1.2),
            pinPitch: mmToMeters(1.0),
            padOuterMargin: mmToMeters(0.25),
        }, existingPadNodes),
        generatePadRules: ssopGeneratePadRules,
        generateAdditionalPads: ssopGenerateAdditionalPads,
        generateSilkNodes: ssopGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // IND-SMD - Inductor SMD (2-pin)
    "IND-SMD": {
        computeInferredRules: (br, existingPadNodes) => chipComputeInferredRules(br, {
            packageHeight: mmToMeters(1.2),
            pinSizeX: mmToMeters(0.8),
            pinSizeY: mmToMeters(1.0),
            padSpacing: mmToMeters(2.5),
            packageLength: mmToMeters(3.2),
            packageWidth: mmToMeters(2.5),
        }, existingPadNodes),
        generatePadRules: chipGeneratePadRules,
        generateAdditionalPads: chipGenerateAdditionalPads,
        generateSilkNodes: chipGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // PWRM-SMD - Power Management SMD
    "PWRM-SMD": {
        computeInferredRules: (br, existingPadNodes) => dfnComputeInferredRules(br, {
            packageHeight: mmToMeters(1.0),
            pinSizeX: mmToMeters(0.3),
            pinSizeY: mmToMeters(0.6),
            pinPitch: mmToMeters(0.5),
            padOuterMargin: mmToMeters(0.25),
        }, existingPadNodes),
        generatePadRules: dfnGeneratePadRules,
        generateAdditionalPads: dfnGenerateAdditionalPads,
        generateSilkNodes: dfnGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // PCIE-SMD - PCIe Connector SMD
    "PCIE-SMD": {
        computeInferredRules: (br, existingPadNodes) => ssopComputeInferredRules(br, {
            packageHeight: mmToMeters(8.0),
            pinSizeX: mmToMeters(0.5),
            pinSizeY: mmToMeters(2.0),
            pinPitch: mmToMeters(1.0),
            padOuterMargin: mmToMeters(0.25),
        }, existingPadNodes),
        generatePadRules: ssopGeneratePadRules,
        generateAdditionalPads: ssopGenerateAdditionalPads,
        generateSilkNodes: ssopGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // OLED-SMD_UG - OLED Display SMD
    "OLED-SMD_UG": {
        computeInferredRules: (br, existingPadNodes) => ssopComputeInferredRules(br, {
            packageHeight: mmToMeters(2.0),
            pinSizeX: mmToMeters(0.3),
            pinSizeY: mmToMeters(0.8),
            pinPitch: mmToMeters(0.5),
            padOuterMargin: mmToMeters(0.25),
        }, existingPadNodes),
        generatePadRules: ssopGeneratePadRules,
        generateAdditionalPads: ssopGenerateAdditionalPads,
        generateSilkNodes: ssopGenerateSilkNodes,
        generate3DModelNode: commonGenerate3DModelNode,
    },
    // Chip component packages(resistors, capacitors, inductors, diodes)
    ...Object.keys(chipPackageDimensions).reduce((acc, sizeCode) => {
        const config = getChipConfig(sizeCode);
        // Add R_ prefix variants (resistors)
        acc[`R_${sizeCode}`] = {
            computeInferredRules: (br, existingPadNodes) => chipComputeInferredRules(br, {
                packageHeight: config.packageHeight,
                pinSizeX: config.pinSizeX,
                pinSizeY: config.pinSizeY,
                padSpacing: config.padSpacing,
                packageLength: config.packageLength,
                packageWidth: config.packageWidth,
            }, existingPadNodes),
            generatePadRules: chipGeneratePadRules,
            generateAdditionalPads: chipGenerateAdditionalPads,
            generateSilkNodes: chipGenerateSilkNodes,
            generate3DModelNode: commonGenerate3DModelNode,
        };
        // Add C_ prefix variants (capacitors)
        acc[`C_${sizeCode}`] = {
            computeInferredRules: (br, existingPadNodes) => chipComputeInferredRules(br, {
                packageHeight: config.packageHeight,
                pinSizeX: config.pinSizeX,
                pinSizeY: config.pinSizeY,
                padSpacing: config.padSpacing,
                packageLength: config.packageLength,
                packageWidth: config.packageWidth,
            }, existingPadNodes),
            generatePadRules: chipGeneratePadRules,
            generateAdditionalPads: chipGenerateAdditionalPads,
            generateSilkNodes: chipGenerateSilkNodes,
            generate3DModelNode: commonGenerate3DModelNode,
        };
        // Add L_ prefix variants (inductors)
        acc[`L_${sizeCode}`] = {
            computeInferredRules: (br, existingPadNodes) => chipComputeInferredRules(br, {
                packageHeight: config.packageHeight,
                pinSizeX: config.pinSizeX,
                pinSizeY: config.pinSizeY,
                padSpacing: config.padSpacing,
                packageLength: config.packageLength,
                packageWidth: config.packageWidth,
            }, existingPadNodes),
            generatePadRules: chipGeneratePadRules,
            generateAdditionalPads: chipGenerateAdditionalPads,
            generateSilkNodes: chipGenerateSilkNodes,
            generate3DModelNode: commonGenerate3DModelNode,
        };
        // Add D_ prefix variants (diodes)
        acc[`D_${sizeCode}`] = {
            computeInferredRules: (br, existingPadNodes) => chipComputeInferredRules(br, {
                packageHeight: config.packageHeight,
                pinSizeX: config.pinSizeX,
                pinSizeY: config.pinSizeY,
                padSpacing: config.padSpacing,
                packageLength: config.packageLength,
                packageWidth: config.packageWidth,
            }, existingPadNodes),
            generatePadRules: chipGeneratePadRules,
            generateAdditionalPads: chipGenerateAdditionalPads,
            generateSilkNodes: chipGenerateSilkNodes,
            generate3DModelNode: commonGenerate3DModelNode,
        };
        return acc;
    }, {}),
};
/**
 * Supported parametric package types that can be used with the package rule
 * These must match the keys in the packages object above
 * Order matters - more specific package types should come first to avoid false matches
 * (e.g., "SOT-23" should be checked before "SOT")
 */
export const PARAMETRIC_PACKAGE_TYPES = [
    // Grid array packages (BGA variants - specific first)
    "Grid Array",
    "LFBGA",
    "TFBGA",
    "VFBGA",
    "UFBGA",
    "WFBGA",
    "FCBGA",
    "UCBGA",
    "TBGA",
    "DSBGA",
    "PBGA",
    "CABGA",
    "UBGA",
    "XBGA",
    "FBGA",
    "BGA",
    "CSP",
    "LGA",
    // Wafer level packages
    "WLCSP",
    "FOWLP",
    "WLP",
    // Quad flat packages (QFP variants - specific first)
    "LQFP",
    "TQFP",
    "VQFP",
    "PQFP",
    "CQFP",
    "BQFP",
    "HQFP",
    "QFP",
    "PLCC",
    // QFN variants (specific first)
    "VQFN",
    "WQFN",
    "TQFN",
    "UQFN",
    "HVQFN",
    "VFQFN",
    "WFQFN",
    "UFQFPN",
    "QFN",
    // Small outline packages (SSOP/SOP variants - specific first)
    "VSSOP",
    "HVSSOP",
    "MSSSOP",
    "VTSOP",
    "QSOP",
    "MSOP",
    "SSOP",
    "SOIC",
    "SOP",
    "TSSOP",
    // TSOP packages
    "TSOP-I",
    "TSOP-II",
    "TSOP",
    // DFN/WSON packages (specific variants first)
    "TDFN",
    "WDFN",
    "UDFN",
    "VDFN",
    "XDFN",
    "VSON",
    "USON",
    "DFN",
    "WSON",
    // DIP packages (specific variants first)
    "SPDIP",
    "SDIP",
    "CDIP",
    "PDIP",
    "DIP",
    // SIP/ZIP packages
    "SIP",
    "ZIP",
    // TO packages (specific variants first)
    "TO-92",
    "TO-220",
    "TO-252",
    "TO-263",
    "D2PAK",
    "DPAK",
    // SOT packages (specific variants first)
    "SOT-23-5",
    "SOT-23-6",
    "SOT-23-8",
    "SOT-23",
    "SOT-223",
    "SOT-89",
    "SOT-323",
    "SOT-363",
    "SOT-143",
    "SOT-416",
    "SOT-666",
    "SOT-723",
    "SC-70",
    "TSOT-23",
    // Additional TSSOP variants
    "HTSSOP",
    "ETSSOP",
    // Additional QFP variants
    "HTQFP",
    "EQFP",
    "HLQFP",
    // J-lead packages
    "SOJ",
    // Very small outline packages
    "VSOP",
    "VSO",
    // Micro lead frame packages
    "MLPQ",
    "MLF",
    "LFCSP",
    "FCCSP",
    // Additional BGA variants
    "FPBGA",
    "FTBGA",
    "CSFBGA",
    "LBGA",
    "VBGA",
    "MBGA",
    "CSPBGA",
    "CSBGA",
    // Ultra small packages
    "USP",
    // Generic small outline
    "SO",
    "SMDIP",
    // Power packages
    "PowerSMD",
    "POWERDI",
    "POWERDIP",
    "POWERVDFN",
    // Diode packages
    "DO",
    "SOD",
    "MELF",
    "SMC",
    "P600",
    // Other packages
    "SSOT",
    "CSMD",
    "PLAD",
    "FLIPCHIP",
    "BPX",
    // Base family packages
    "SOT",
    "TO",
    "TSOT",
    // Passive component packages
    "CP",
    "CPOL",
    "SMD",
    "TH",
    "R",
    "C",
    "L",
    "D",
    // Module and connector packages
    "MODULE",
    "FPGA",
    "XCVR",
    "CMWX",
    "DIN",
    "USB",
    "RHDR",
    "DISP",
    // SMD-Component family packages
    "RES-ARRAY-SMD",
    "RES-ADJ-SMD",
    "KEY-SMD",
    "SW-SMD",
    "OSC-SMD",
    "CRYSTAL-SMD",
    "CONN-SMD",
    "IND-SMD",
    "PWRM-SMD",
    "PCIE-SMD",
    "OLED-SMD_UG",
];
/**
 * Extracts the parametric package type from a package case code
 * For example: "8-SOIC" -> undefined (SOIC not supported), "16-QFN" -> "QFN", "SSOP-20" -> "SSOP"
 */
export function extractPackageType(packageCaseCode) {
    if (!packageCaseCode)
        return undefined;
    const lowerCaseCode = packageCaseCode.toLowerCase();
    for (const packageType of PARAMETRIC_PACKAGE_TYPES) {
        if (lowerCaseCode.includes(packageType.toLowerCase())) {
            return packageType;
        }
    }
    return undefined;
}
export function isParametricImportSupported(packageName) {
    if (!packageName)
        return false;
    // Check if the package name contains any of the package names
    return Object.keys(packages).some((name) => packageName.toLowerCase().includes(name.toLowerCase()));
}
//# sourceMappingURL=packages.js.map